/* eslint-disable no-undef */
import axios from 'api/axios'

export type BroadcastReportTypes =
	| 'ALL'
	| 'DELIVERED'
	| 'UNDELIVERED'
	| 'FAILED'
	| 'SENT'
	| 'READ'
	| 'REPLY'

export interface GetBroadcastResponseOptions {
	type: BroadcastReportTypes
	id: string
	clientId?: string
}

const getBroadcastReportExport = async (
	options: GetBroadcastResponseOptions
): Promise<BlobPart> => {
	const { id, type, clientId } = options

	// TODO: Change endpoint to correct one
	const { data } = await axios.get<BlobPart>(
		`v1/broadcast/management/broadcast-report-export/${id}`,
		{
			params: {
				status: type !== 'ALL' ? type : '',
				client: clientId,
			},
		}
	)
	return data
}

export default getBroadcastReportExport
